<ion-app id="sopo-app" [style]="{
    '--sopo-popup-font-size': sopoPopupFontSize$ | async,
    '--common-font-size': commonFontSize()
}">
    <!--  our side menu  -->
    <!-- the main content -->
    <ion-header>
        <app-header *ngIf="showHeader" id="header"></app-header>
    </ion-header>
    <ion-content>
        <ion-router-outlet id="router-outlet-container" [animated]="false"></ion-router-outlet>
        <show-maintenance></show-maintenance>
        <ng-template #sweepbuckMenu></ng-template>
        <ng-template #shopProduct></ng-template>
    </ion-content>
    <ng-template #certificatePreview></ng-template>
    <ng-template #reCaptcha></ng-template>
    <ng-template #sopoTransition></ng-template>
    <ng-template #appContainer></ng-template>
    <ng-template #abstractLogin></ng-template>
    <ng-template #sopoTooltip></ng-template>
    <ng-template #profileSetup></ng-template>
</ion-app>
